var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrdersIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnssvgjs: "http://svgjs.com/svgjs",
    x: 0,
    y: 0,
    viewBox: "0 0 511.999 511.999",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m476.919 141.304-.379-.655a24.171 24.171 0 0 0-1.807-3.123L403.504 14.38C398.373 5.51 388.821 0 378.574 0H133.437c-10.263 0-19.823 5.523-24.952 14.417l-72.39 125.586a15.026 15.026 0 0 0-1.454 3.519 25.36 25.36 0 0 0-1.579 8.826v324.365c0 19.456 15.829 35.285 35.285 35.285h375.304c19.456 0 35.285-15.829 35.285-35.285V151.159c0-.435-.013-.867-.036-1.297a14.93 14.93 0 0 0-1.981-8.558zM271.518 30.011h106.358l56.032 96.873h-162.39V30.011zm-137.382 0h107.371v96.873H78.296l55.84-96.873zm314.789 446.703a5.28 5.28 0 0 1-5.274 5.274H68.347a5.28 5.28 0 0 1-5.274-5.274V156.895h385.852v319.819z",
    fill: "currentColor",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.115 270.026c-5.859-5.859-15.361-5.859-21.221 0l-67.002 67.002-25.764-25.764c-5.859-5.859-15.361-5.859-21.221 0-5.86 5.859-5.86 15.361 0 21.221l36.376 36.374a14.96 14.96 0 0 0 10.61 4.396c3.839 0 7.681-1.466 10.61-4.396l77.612-77.612c5.86-5.86 5.86-15.361 0-21.221z",
    fill: "currentColor",
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdersIcon);
export default __webpack_public_path__ + "static/media/ordersIcon.481cb8a0adc76d83c8e778878d429c40.svg";
export { ForwardRef as ReactComponent };